import axios from "axios";
import { emitToastr } from "./Utils";

const API_URL = process.env.VUE_APP_URL ? process.env.VUE_APP_URL : process.env.NODE_ENV === "development" ? "http://localhost:3005/admin" : "https://painel.inteligenciabot.com/admin";

class Api {
  login = async (email, password, remember, admin_login = false, customer_email) => {
    const endpoint = "/auth";
    let result = await this.authPost(endpoint, { email, password, remember, admin_login, customer_email });

    if (result && result.token && result.user) {
      window.localStorage.setItem("token", result.token);
      delete result.token;
      window.localStorage.setItem("user", JSON.stringify(result.user));
      result.login_ok = true;
    }

    return result;
  };

  logout = async () => {
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("token");
    window.location.href = "/login";
  };

  getUser = () => {
    let user = window.localStorage.getItem("user");
    try {
      user = JSON.parse(user);
      return user;
    } catch {
      return {};
    }
  };

  getToken = () => {
    return window.localStorage.getItem("token") || "";
  };

  getRemoteUser = async () => {
    const user = await this.authPost("/get-user", {}, {});

    if (user && user._id) {
      window.localStorage.setItem("user", JSON.stringify(user));
      return user;
    }

    return false;
  };

  uploadProfilePicture = async (image) => {
    const resp = await this.authPost("/upload-profile-picture", { image: image }, { multipart: true, formData: true }); //ESSE TEM ESSAS OPÇÕES PORQUE ESTÁ ENVIANDO UMA IMAGEM AO INVÉS DE UM JSON
    return resp;
  };

  uploadImage = async (image) => {
    const resp = await this.authPost("/upload-image", { image: image }, { multipart: true, formData: true });
    return resp;
  };

  uploadFile = async (file, type, filename, temp = false) => {
    const resp = await this.authPost("/upload-file", { file, type, filename, temp }, { multipart: true, formData: true });
    return resp;
  };

  createUser = async (email, password, name, phone) => {
    const resp = await this.authPost("/create-user", { email, password, name, phone }, {});

    if (resp && resp.new_user && resp.token) {
      window.localStorage.setItem("token", resp.token);
      window.localStorage.setItem("user", JSON.stringify(resp.new_user));
      return true;
    }
    return false;
  }

  updateUser = async (user) => {
    const resp = await this.authPost("/update-user", { user }, {});
    return resp;
  }

  updateUserConfig = async (object) => {
    const resp = await this.authPost("/update-user-config", object, {});
    return resp;
  }

    updateUserInfo = async (user) => {
    const resp = await this.authPost("/update-user-info", { user }, {});
    return resp;
  }

  createTeamUser = async (object) => {
    const resp = await this.authPost("/create-team-user", object, {});
    return resp;
  }

  getTeamUsers = async () => {
    const resp = await this.authPost("/get-team-users", {}, {});
    return resp;
  }

  getUsers = async () => {
    const resp = await this.authPost("/get-users", {}, {});
    return resp;
  }

  getSalesByUserAndMode = async () => {
    return {}
  }

  createOrUpdateChipNumber = async (object) => {
    const resp = await this.authPost("/create-or-update-chip-number", object, {});
    return resp;
  }

  getChipNumbersByUser = async () => {
    const resp = await this.authPost("/get-chip-numbers-by-user", {}, {});
    return resp;
  }

  connectChipNumber = async (chip, connect = true) => {
    const resp = await this.authPost("/connect-chip-number", { chip, connect }, {});
    return resp;
  }

  officialSignup = async (payload) => {
    const resp = await this.authPost("/official-signup", payload, {});
    return resp;
  }

  changeChipNumberChatbot = async (chip) => {
    const resp = await this.authPost("/change-chip-number-chatbot", { chip }, {});
    return resp;
  }

  recoveryPassword = async (email) => {
    const resp = await this.authPost("/send-password-recovery", { email: email }, {});
    return resp;
  };

  changeUserPassword = async (password, old_password) => {
    const resp = await this.authPost("/change-user-password", { password, old_password }, {});
    return resp;
  };

  getDashboardData = async (interval, selected_chip) => {
    const resp = await this.authPost("/get-dashboard-data", { interval, selected_chip }, {});
    return resp;
  };

  getOpportunityMetrics = async (interval) => {
    const resp = await this.authPost("/get-opportunity-metrics", { interval }, {});
    return resp;
  };

  getDashboardRealTimeData = async (selected_chip) => {
    const resp = await this.authPost("/get-dashboard-real-time-data", { selected_chip }, {});
    return resp;
  };

  getAdminDashboardData = async (interval) => {
    const resp = await this.authPost("/get-admin-dashboard-data", { interval }, {});
    return resp;
  };

  getFinancialDashboardData = async () => {
    const resp = await this.authPost("/get-financial-dashboard-data", {}, {});
    return resp;
  };

  createOrUpdateChatbot = async (object) => {
    const resp = await this.authPost("/create-or-update-chatbot", object, {});
    return resp;
  }

  getChatbotsByUser = async () => {
    const resp = await this.authPost("/get-chatbots-by-user", {}, {});
    return resp;
  }

  sandboxMessage = async (object) => {
    const resp = await this.authPost("/sandbox-message", object, {});
    return resp;
  }

  getFlowsByUser = async () => {
    const resp = await this.authPost("/get-flows-by-user", {}, {});
    return resp;
  }

  getFlowById = async (flow_id) => {
    const resp = await this.authPost("/get-flow-by-id", { flow_id }, {});
    return resp;
  }

  createOrUpdateFlow = async (object) => {
    const resp = await this.authPost("/create-or-update-flow", object, {});
    return resp;
  }

  duplicateFlow = async (flow_id, name) => {
    const resp = await this.authPost("/duplicate-flow", { flow_id, name }, {});
    return resp;
  }

  getGlobalVariables = async () => {
    const resp = await this.authPost("/get-global-variables", {}, {});
    return resp;
  }

  updateGlobalVariables = async (variables) => {
    const resp = await this.authPost("/update-global-variables", { variables }, {});
    return resp;
  }

  duplicateChatbot = async (chatbot_id, name) => {
    const resp = await this.authPost("/duplicate-chatbot", { chatbot_id, name }, {});
    return resp;
  }

  getContactsByUser = async (options) => {
    const resp = await this.authPost("/get-contacts-by-user", options, {});
    return resp;
  }

  getContactById = async (contact_id) => {
    const resp = await this.authPost("/get-contact-by-id", { contact_id }, {});
    return resp;
  }

  ignoreContact = async (contact) => {
    const resp = await this.authPost("/ignore-contact", { contact }, {});
    return resp;
  }

  changeContactTags = async (contact, conversation_id) => {
    const resp = await this.authPost("/change-contact-tags", { contact, conversation_id }, {});
    return resp;
  }

  changeContactName = async (contact) => {
    const resp = await this.authPost("/change-contact-name", { contact }, {});
    return resp;
  }

  changeContactAnnotationsAndData = async (contact) => {
    const resp = await this.authPost("/change-contact-annotations-and-data", { contact }, {});
    return resp;
  }

  deleteContact = async (contact) => {
    const resp = await this.authPost("/delete-contact", { contact }, {});
    return resp;
  }

  getConversationsByUser = async (options) => {
    const resp = await this.authPost("/get-conversations-by-user", options, {});
    return resp;
  }

  getConversationsWithLastMessage = async (options) => {
    const resp = await this.authPost("/get-conversations-with-last-message", options, {});
    return resp;
  }

  getConversationsUpdate = async (conversation_id) => {
    const resp = await this.authPost("/get-conversation-update", { conversation_id }, {});
    return resp;
  }

  getMessagesByConversation = async (conversation_id) => {
    const resp = await this.authPost("/get-messages-by-conversation", { conversation_id }, {});
    return resp;
  }

  finishConversation = async (conversation_id) => {
    const resp = await this.authPost("/finish-conversation", { conversation_id }, {});
    return resp;
  }

  finishInactiveConversations = async (payload) => {
    const resp = await this.authPost("/finish-inactive-conversations", payload, {});
    return resp;
  }

  transferConversationsDepartment = async (payload) => {
    const resp = await this.authPost("/transfer-conversations-department", payload, {});
    return resp;
  }

  changeConversationsTag = async (payload) => {
    const resp = await this.authPost("/change-conversations-tag", payload, {});
    return resp;
  }

  resumeConversation = async (conversation_id) => {
    const resp = await this.authPost("/resume-conversation", { conversation_id }, {});
    return resp;
  }

  setConversationManual = async (conversation_id) => {
    const resp = await this.authPost("/set-conversation-manual", { conversation_id }, {});
    return resp;
  }

  changeConversationData = async (conversation) => {
    const resp = await this.authPost("/change-conversation-data", conversation, {});
    return resp;
  }

  createSystemMessage = async (object) => {
    const resp = await this.authPost("/create-system-message", object, {});
    return resp;
  }

  sendConversationMessage = async (conversation_id, text, message_id, media, reply_message) => {
    const resp = await this.authPost("/send-conversation-message", { conversation_id, text, message_id, media, reply_message }, {});
    return resp;
  }

  sendTemplateToConversation = async (conversation_id, template, template_components = []) => {
    const resp = await this.authPost("/send-template-to-conversation", { conversation_id, template, template_components }, {});
    return resp;
  }

  deleteConversationMessage = async (platform_message_id, phone, chip_number_id) => {
    const resp = await this.authPost("/delete-conversation-message", { platform_message_id, phone, chip_number_id }, {});
    return resp;
  }

  getQuickMessagesByUser = async () => {
    const resp = await this.authPost("/get-quick-messages-by-user", {}, {});
    return resp;
  }

  createOrUpdateQuickMessage = async (object) => {
    const resp = await this.authPost("/create-or-update-quick-message", object, {});
    return resp;
  }

  getOpenManualConversationCount = async () => {
    const resp = await this.authPost("/get-open-manual-conversation-count", {}, {});
    return resp;
  }

  getGuruSubscription = async () => {
    const resp = await this.authPost("/get-guru-subscription", {}, {});
    return resp;
  }

  getTagsByUser = async () => {
    const resp = await this.authPost("/get-tags-by-user", {}, {});
    return resp;
  }

  createOrUpdateTag = async (object) => {
    const resp = await this.authPost("/create-or-update-tag", object, {});
    return resp;
  }

  getDepartmentsByUser = async () => {
    const resp = await this.authPost("/get-departments-by-user", {}, {});
    return resp;
  }

  createOrUpdateDepartment = async (object) => {
    const resp = await this.authPost("/create-or-update-department", object, {});
    return resp;
  }

  checkPhone = async (phone, chip) => {
    const resp = await this.authPost("/check-phone", { phone, chip }, {});
    return resp;
  }

  startNewConversation = async (jid, chip, department, template, template_components = []) => {
    const resp = await this.authPost("/start-new-conversation", { jid, chip, department, template, template_components }, {});
    return resp;
  }

  getMediasByUser = async () => {
    const resp = await this.authPost("/get-medias-by-user", {}, {});
    return resp;
  }

  deleteMedia = async (media) => {
    const resp = await this.authPost("/delete-media", media, {});
    return resp;
  }

  getScheduledMessagesByUser = async () => {
    const resp = await this.authPost("/get-scheduled-messages-by-user", {}, {});
    return resp;
  };

  createScheduledMessage = async (object) => {
    const resp = await this.authPost("/create-scheduled-message", object, {});
    return resp;
  };

  updateScheduledMessage = async (object) => {
    const resp = await this.authPost("/update-scheduled-message", object, {});
    return resp;
  };

  getAudienceByUser = async () => {
    const resp = await this.authPost("/get-audience-by-user", {}, {});
    return resp;
  };

  createOrUpdateAudience = async (object) => {
    const resp = await this.authPost("/create-or-update-audience", object, {});
    return resp;
  };

  importContacts = async (object) => {
    const resp = await this.authPost("/import-contacts", object, {});
    return resp;
  };

  sendAudienceList = async (data, file, save = false) => {
    const endpoint = '/import-audience-sheet';
    const result = await this.authPost(endpoint, { ...data, file: file, save: save }, { multipart: true, formData: true });
    return result;
  }

  getCampaignsByUser = async (filter) => {
    const resp = await this.authPost("/get-campaigns-by-user", filter, {});
    return resp;
  };

  createCampaign = async (object) => {
    const resp = await this.authPost("/create-campaign", object, {});
    return resp;
  };

  updateCampaign = async (object) => {
    const resp = await this.authPost("/update-campaign", object, {});
    return resp;
  };

  getCampaignRealTimeData = async (object) => {
    const resp = await this.authPost("/get-campaign-real-time-data", object, {});
    return resp;
  };

  createOrUpdateOfficialCampaign = async (object) => {
    const resp = await this.authPost("/create-or-update-official-campaign", object, {});
    return resp;
  };


  updateUserApiKey = async () => {
    const resp = await this.authPost("/update-api-key", {}, {});
    return resp;
  }

  exportContacts = async (options = {}) => {
    const endpoint = '/export-contacts';
    const result = await this.authPost(endpoint, options, { arraybuffer: true });
    return result;
  }

  getCustomers = async (options) => {
    const resp = await this.authPost("/get-customers", options, {});
    return resp;
  }

  updateAccount = async (object) => {
    const resp = await this.authPost("/update-account", object, {});
    return resp;
  }

  applyAiModelToChatbots = async (account_id, ai_model) => {
    const resp = await this.authPost("/apply-ai-model-to-account-chatbots", { account_id, ai_model }, {});
    return resp;
  }

  changeCustomerPassword = async (user_id, new_password) => {
    const resp = await this.authPost("/change-customer-password", { user_id, new_password }, {});
    return resp;
  }

  getMessageServers = async () => {
    const resp = await this.authPost("/get-message-servers", {}, {});
    return resp;
  }

  getChatbotModels = async () => {
    const resp = await this.authPost("/get-chatbot-models", {}, {});
    return resp;
  }

  summarizeMessages = async (conversation_id, messages = []) => {
    const resp = await this.authPost("/summarize-messages", { conversation_id, messages }, {});
    return resp;
  }

  createAIFollowUp = async (conversation_id, messages = []) => {
    const resp = await this.authPost("/create-ai-follow-up", { conversation_id, messages }, {});
    return resp;
  }

  createAIReply = async (conversation_id, messages = []) => {
    const resp = await this.authPost("/create-ai-reply", { conversation_id, messages }, {});
    return resp;
  }

  getOnlineUsers = async () => {
    const resp = await this.authPost("/get-online-users", {}, {});
    return resp;
  }

  getAutoFollowUps = async () => {
    const resp = await this.authPost("/get-auto-follow-ups", {}, {});
    return resp;
  }

  updateAutoFollowUp = async (object) => {
    const resp = await this.authPost("/update-auto-follow-up", object, {});
    return resp;
  }

  getWebhooksByUser = async () => {
    const resp = await this.authPost("/get-webhooks-by-user", {}, {});
    return resp;
  }

  getWebhookById = async (webhook_id) => {
    const resp = await this.authPost("/get-webhook-by-id", { webhook_id }, {});
    return resp;
  }

  createOrUpdateWebhook = async (object) => {
    const resp = await this.authPost("/create-or-update-webhook", object, {});
    return resp;
  }

  getTemplateMessages = async (waba) => {
    const resp = await this.authPost("/get-template-messages", {waba}, {});
    return resp;
  };

  createTemplateMessage = async (object) => {
    const resp = await this.authPost("/create-template-message", object, {});
    return resp;
  }

  deleteTemplateMessage = async (object) => {
    const resp = await this.authPost("/delete-template-message", object, {});
    return resp;
  }

  getGuruOffers = async () => {
    const resp = await this.authPost("/get-guru-offers", {}, {});
    return resp;
  };

  createOrUpdateGuruOffer = async (object) => {
    const resp = await this.authPost("/create-or-update-guru-offer", object, {});
    return resp;
  }

  getOfficialChipNumbersByAccount = async (account) => {
    const resp = await this.authPost("/get-official-chip-numbers-by-account", { account }, {});
    return resp;
  }

  getNonOfficialChipNumbersByAccount = async (account) => {
    const resp = await this.authPost("/get-non-official-chip-numbers-by-account", { account }, {});
    return resp;
  }

  getPhoneNumberId = async (asset_id) => {
    const resp = await this.authPost("/get-phone-id", { asset_id }, {});
    return resp;
  }

  registerPhoneNumberId = async (asset_id, phone_number_id, deregister = false, coex = false) => {
    const resp = await this.authPost("/register-phone-id", { asset_id, phone_number_id, deregister, coex }, {});
    return resp;
  }

  adminUpdateChipNumber = async (chip_id, fields) => {
    const resp = await this.authPost("/admin-update-chip-number", { chip_id, fields }, {});
    return resp;
  }

  adminCreateChipNumber = async (waba, phone, account_id) => {
    const resp = await this.authPost("/admin-create-chip-number", { waba, phone, account_id }, {});
    return resp;
  }

  adminCreateAccount = async (email, admin_password) => {
    const resp = await this.authPost("/admin-create-account", { email, admin_password }, {});
    return resp;
  }

  adminCancelAccount = async (user_id, account_id, admin_password) => {
    const resp = await this.authPost("/admin-cancel-account", { user_id, account_id, admin_password }, {});
    return resp;
  }

  getFunnelsByAccount = async () => {
    const resp = await this.authPost("/get-funnels-by-account", {}, {});
    return resp;
  }

  getFullFunnelById = async (funnel_id, filters = null) => {
    const payload = { funnel_id };
    if (filters) payload.filters = filters;
    const resp = await this.authPost("/get-full-funnel-by-id", payload, {});
    return resp;
  }

  getFunnelStepOpportunities = async (funnel_id, step_id, skip = 0, limit = 20, filters = null) => {
    const payload = { funnel_id, step_id, skip, limit };
    if (filters) payload.filters = filters;
    const resp = await this.authPost("/get-funnel-step-opportunities", payload, {});
    return resp;
  }

  getStepsByFunnel = async (funnel_id) => {
    const resp = await this.authPost("/get-steps-by-funnel", { funnel_id }, {});
    return resp;
  }

  createOrUpdateFunnel = async (object) => {
    const resp = await this.authPost("/create-or-update-funnel", object, {});
    return resp;
  }

  createOrUpdateStep = async (object) => {
    const resp = await this.authPost("/create-or-update-step", object, {});
    return resp;
  }

  createOrUpdateOpportunity = async (object) => {
    const resp = await this.authPost("/create-or-update-opportunity", object, {});
    return resp;
  }

  updateOpportunityPosition = async (opportunity_id, new_step_id, before_opportunity_id, after_opportunity_id) => {
    const resp = await this.authPost("/update-opportunity-position", { opportunity_id, new_step_id, before_opportunity_id, after_opportunity_id }, {});
    return resp;
  }

  updateOpportunityStatus = async (opportunity_id, status, final_value = null, loss_reason = null) => {
    const resp = await this.authPost("/update-opportunity-status", { opportunity_id, status, final_value, loss_reason }, {});
    return resp;
  }

  checkErrorsWithStatusCode200 = (data) => {
    if (data.error) {
      emitToastr("error", data.message || "Erro não identificado!", "Erro");
    }

    return data;
  };

  get = (url) =>
    axios
      .get(`${API_URL}${url}`)
      .then((response) => this.checkErrorsWithStatusCode200(response.data))
      .catch(() => {
        emitToastr("error", "Erro genérico de servidor!", "Erro");
      });

  authGet = (url, data) =>
    axios
      .get(`${API_URL}${url}`, { headers: { auth: this.getToken() }, params: data })
      .then((response) => this.checkErrorsWithStatusCode200(response.data))
      .catch((err) => {
        if (err && err.response && err.response.status === 401) {
          emitToastr("error", "Erro de servidor! Confira se as informações enviadas estão completas e no formato correto e tente novamente.", "Erro");
          if (err.response.data && err.response.data.logoff === true) this.logout();
        } else {
          if (err.response && err.response.data && err.response.data.error && err.response.data.message) return emitToastr("error", err.response.data.message);
          console.log("Erro genérico de servidor");
        }
      });

  authPost = (url, data, options) => {
    const headers = { auth: this.getToken() };
    if (options) {
      if (options.multipart) {
        headers["Content-Type"] = "multipart/form-data";
      }
      if (options.formData) {
        let formData = new FormData();
        for (let key in data) {
          formData.append(key, data[key]);
        }
        data = formData;
      }
    }
    return axios
      .post(`${API_URL}${url}`, data, { headers, responseType: options && options.arraybuffer ? 'arraybuffer' : undefined })
      .then((response) => this.checkErrorsWithStatusCode200(response.data))
      .catch((err) => {
        console.error(err.response);
        if (err && err.response && err.response.status === 401) {
          emitToastr("error", "Erro de servidor! Confira se as informações enviadas estão completas e no formato correto e tente novamente.", "Erro");
          if (err.response.data && err.response.data.logoff === true) this.logout();
        } else {
          if (err.response && err.response.data && err.response.data.error && err.response.data.message) {
            return { error: true, message: err.response.data.message };
          } else if (err.response && err.response.status) emitToastr("error", err.response.statusText + " (status: " + err.response.status + ")", "Erro");
          else emitToastr("error", "Erro genérico de servidor!", "Erro");
          err.response.error = err.response.error || true;
          return err.response;
        }
      });
  };
}

export default new Api();
